var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H31C32.6569 0 34 1.34315 34 3V31C34 32.6569 32.6569 34 31 34H3C1.34315 34 0 32.6569 0 31V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.96 13.8984C24.56 14.2084 26.03 16.0584 26.03 20.1084V20.2384C26.03 24.7084 24.24 26.4984 19.77 26.4984H13.26C8.79 26.4984 7 24.7084 7 20.2384V20.1084C7 16.0884 8.45 14.2384 11.99 13.9084",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5195 7V19.88",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.868 17.6484L16.518 20.9984L13.168 17.6484",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H31V-1H3V1ZM33 3V31H35V3H33ZM31 33H3V35H31V33ZM1 31V3H-1V31H1ZM3 33C1.89543 33 1 32.1046 1 31H-1C-1 33.2091 0.790862 35 3 35V33ZM33 31C33 32.1046 32.1046 33 31 33V35C33.2091 35 35 33.2091 35 31H33ZM31 1C32.1046 1 33 1.89543 33 3H35C35 0.790861 33.2091 -1 31 -1V1ZM3 -1C0.790861 -1 -1 0.790862 -1 3H1C1 1.89543 1.89543 1 3 1V-1Z",
    fill: "#E7E6E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c313fc66030150691ced69c8164476f9.svg";
export { ForwardRef as ReactComponent };